export class SortStore {
    constructor(
        public userId: number,
        public sort: string) {
    }
}